// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"131": "mui","248": "plotly","37": "markdown","505": "mermaid","699": "xlsx","736": "framer-motion","863": "pdf-export",}[chunkId] || chunkId) + "." + {"131": "c9f74176","248": "18f773bb","341": "1b617958","37": "34e7b8d7","490": "c2109686","505": "3508cdd6","699": "4d64f9af","736": "4f496ffb","810": "3172cf92","863": "c0f842ea","923": "b2c21a11",}[chunkId] + ".chunk.js"
}